var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticStyle:{"flex-basis":"auto"},attrs:{"xs12":"","px-3":""}},[_c('v-text-field',{attrs:{"label":"Search Term","clearable":"","append-icon":"mdi-magnify"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }